import { useTranslation } from "next-i18next";
import { Flex, Stack, StackProps } from "@chakra-ui/react";
import { isAddressEqual } from "@looksrare/utils";
import { WatchlistCollectionSearchResult } from "types/graphql";
import { Button } from "uikit";
import { CollectionResult } from "./CollectionResult";

interface CollectionResultsProps extends StackProps {
  collections: WatchlistCollectionSearchResult[];
  selectedCollections: WatchlistCollectionSearchResult[];
  toggleSelectedCollection: (collection: WatchlistCollectionSearchResult) => void;
  hasNextPage?: boolean;
  isFetching?: boolean;
  fetchNextPage?: () => void;
}
export const CollectionResults = ({
  collections,
  selectedCollections,
  toggleSelectedCollection,
  hasNextPage = false,
  isFetching = false,
  fetchNextPage,
  ...props
}: CollectionResultsProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={0} mb={4} overflowY="auto" {...props}>
      {collections.map((collection) => {
        const isSelected = !!selectedCollections.some((coll) => isAddressEqual(coll.address, collection.address));
        return (
          <CollectionResult
            key={collection.address}
            collection={collection}
            isSelected={isSelected}
            toggleIsSelected={toggleSelectedCollection}
          />
        );
      })}
      {!!(hasNextPage && fetchNextPage) && (
        <Flex justifyContent="center" py={2}>
          <Button isLoading={isFetching} isDisabled={isFetching} onClick={() => fetchNextPage()}>
            {t("Load More")}
          </Button>
        </Flex>
      )}
    </Stack>
  );
};
